import { requst } from '../config'

// 日历上数据
export const getUSVCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/usv/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getUSVDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 查询日期
export const getUSVByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/usv/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getUSVByIdApi = id => {
    const url = `/monitor/usv/${id}`
    return requst.get(url)
}

// 获取激活数据
export const getUSVActivityDataApi = id => {
    const url = `/monitor/usv/activity/list?usvId=${id}`
    return requst.get(url)
}

// 提交总结
export const postUSVCommentApi = commentData => {
    const url = `/monitor/usv`
    return requst.post(url, { ...commentData })
}

// 修改总结
export const putUSVCommentApi = (commentData, id) => {
    const url = `/monitor/usv`
    return requst.put(url, { ...commentData, id })
}

// 提交激活
export const postUSVActivityDataApi = (activityData, id) => {
    const url = `/monitor/usv/activity/addOrUpdateBatch/${id}`
    return requst.post(url, activityData)
}
